import { render } from "./OtherView.vue?vue&type=template&id=90e86d10&scoped=true&ts=true"
import script from "./OtherView.vue?vue&type=script&lang=ts"
export * from "./OtherView.vue?vue&type=script&lang=ts"

import "./OtherView.vue?vue&type=style&index=0&id=90e86d10&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90e86d10"]])

export default __exports__